import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {EmploymentService} from '../employment.service';
import {MemberRelationData} from '../employment.model';
import {HiddenRequestsService} from '../hidden-requests.service';

@Component({
    selector: 'app-jobs-overview',
    templateUrl: './jobs-overview.component.html',
    styleUrls: ['./jobs-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class JobsOverviewComponent implements OnInit {
    isLoaded = false;

    readonly emailFeedbackPlatfrom: string = 'mailto:feedback@clea.app?subject=' + encodeURIComponent($localize`:@@emailFeedbackPlatfrom:Feedback Nutzung CléA Jobplattform`);

    constructor(
        public employment: EmploymentService,
        private _cdr: ChangeDetectorRef,
        private hiddenRequests: HiddenRequestsService,
    ) {
    }

    get visibleRelations(): MemberRelationData[] {
        return this.employment.relations
            .filter(r => {
                if (r.relation && this.hiddenRequests.isHidden(r.relation.memberId)) {
                    if (r.unreadMessages > 0) {
                        this.hiddenRequests.unhide(r.relation.memberId);
                        return true;
                    }
                    return false;
                }
                return true;
            })
            .sort((a, b) => {
                if (a.unreadMessages > 0 && b.unreadMessages === 0) { return -1; }
                if (a.unreadMessages === 0 && b.unreadMessages > 0) { return 1; }
                if (a.unreadMessages > 0 && b.unreadMessages > 0) {
                    return (b.lastMessageTimeStamp || '').localeCompare(a.lastMessageTimeStamp || '');
                }
                return 0;
            });
    }

    onRequestRemoved(relationId: string): void {
        this._cdr.detectChanges();
    }

    ngOnInit(): void {
        this.employment.loadRelations('Employee').subscribe({
            complete: () => {
                this.isLoaded = true;
                this._cdr.detectChanges();
            },
            error: () => {
                this.isLoaded = true;
                this._cdr.detectChanges();
            }
        });
    }

}
